import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { handleToastError, hasPermission } from 'helpers';
import {
  adminGetListUnitsAsync,
  getCourse,
  getCourseAsync,
  getCourseError,
  getListUnits,
  learnerGetListUnitsAsync,
  setCourse,
  setCourseError,
  setListUnits,
} from 'store/course';
import useI18n from '../use-i18n';
import { useUser, useViewMode } from '../index';
import { USER_METHODS, USER_ROLES } from '../../constants/constants';

const LIMIT = 150;

export const useListUnits = () => useSelector(getListUnits);

export const useFetchListUnits = () => {
  const dispatch = useDispatch();
  const i18n = useI18n();
  const viewMode = useViewMode();
  const auth = useUser();
  const {
    back,
    query: { slug },
  } = useRouter();
  useEffect(() => {
    const callApi = async () => {
      try {
        if (slug) {
          if (
            hasPermission(
              USER_METHODS.GET,
              'user-courses/get-units',
              auth,
              viewMode,
            )
          ) {
            await dispatch(setListUnits(undefined));
            if (viewMode === USER_ROLES.LEARNER) {
              const params = {
                id: slug,
              };
              await dispatch(learnerGetListUnitsAsync(params));
            } else {
              const params = {
                course: slug,
                page: 1,
                limit: LIMIT,
                type: 'unit',
              };
              await dispatch(adminGetListUnitsAsync(params));
            }
          } else {
            await dispatch(setListUnits([]));
          }
        }
      } catch (e) {
        back();
        handleToastError(e, i18n);
      }
    };

    callApi();
  }, []);
};

// course
export const useCourse = () => useSelector(getCourse);
export const useCourseError = () => useSelector(getCourseError);

export const useFetchCourse = (params) => {
  const dispatch = useDispatch();
  const {
    query: { slug },
  } = useRouter();
  useEffect(() => {
    const callApi = async () => {
      try {
        await dispatch(setCourse(undefined));
        await dispatch(getCourseAsync(slug, params));
      } catch (e) {
        await dispatch(
          setCourseError({
            data: e?.response?.data,
            status: e?.response?.status,
          }),
        );
      }
    };

    callApi();
  }, []);
};

export const getListUnitsCourse = (slug, role) => async (dispatch) => {
  try {
    if (role === USER_ROLES.LEARNER) {
      const params = {
        id: slug,
      };
      await dispatch(learnerGetListUnitsAsync(params));
    } else {
      const params = {
        course: slug,
        page: 1,
        limit: LIMIT,
        type: 'unit',
      };
      await dispatch(adminGetListUnitsAsync(params));
    }
  } catch (error) {
    console.log(error);
  }
};
